import { notificationTypes } from 'constants/index';
import React, { createContext, useState, useContext, useEffect } from 'react';
import { connectToSocket } from 'services/notification/notificationService';
import Cookies from 'universal-cookie';
const cookie = new Cookies();
const WebSocketConnectionContext = createContext(null);

export const useWebSocketContext = () => useContext(WebSocketConnectionContext);

const WebSocketConnectionProvider = (props) => {
  const [notificationPopup, setNotificationPopup] = useState(false);
  const [notificationData, setNotificationData] = useState();
  const [response, setResponse] = useState();
  const [secureMessageData, setSecureMessageData] = useState();
  const [sideBarMessages, setSideBarMessages] = useState();
  const [secureMessageError, setSecureMessageError] = useState();
  const [assignedTaskData, setAssignedTaskData] = useState();
  const [textMessageData, setTextMessageData] = useState();
  const [timeEntryData, setTimeEntryData] = useState();
  const [clientLogout, setClientLogout] = useState();
  const [automationErrorLogData, setAutomationErrorLogData] = useState();
  const [aiFileSummary, setAiFileSummary] = useState();
  const [caseEmails, setCaseEmails] = useState();
  const [aiCourtDate, setAiCourtDate] = useState();
  const [aiEntitiesData, setAiEntitiesData] = useState();
  const [aiTimelineData, setAiTimelineData] = useState();
  const [folderDownloadData, setFolderDownloadData] = useState();
  const [caseNotePDFDownloadData, setCaseNotePDFDownloadData] = useState();
  const [isConnected, setIsConnected] = useState(false);
  let interval = '';
  let [socket, setSocket] = useState();

  const connectToWebSocket = async (tenant_id, user, access_level) => {
    if (!socket) {
      let _socket = connectToSocket(tenant_id, user, access_level);
      setSocket(_socket);
      _socket.onopen = (e) => {
        setIsConnected(true);
      };
      _socket.onmessage = (e) => {
        let data = JSON.parse(e?.data);
        if (data) {
          if (notificationTypes?.includes(data?.notification_type)) {
            setNotificationData(data);
          }

          if (data?.notification_type === 'server_status') {
            if (data?.body?.execution_status === 'success') {
              setResponse({ ...data });
            } else {
              setSecureMessageError({ ...data });
            }
          } else if (data?.notification_type === 'sidebar_message') {
            setSideBarMessages({ ...data });
          } else if (data?.notification_type === 'secure_message') {
            setSecureMessageData({ ...data });
          } else if (data?.notification_type === 'assignment') {
            setAssignedTaskData({ ...data });
          } else if (data?.notification_type === 'time_entry_response') {
            setTimeEntryData({ ...data });
          } else if (data?.notification_type === 'firm_Admin_change') {
            setAssignedTaskData({ ...data });
          } else if (data?.notification_type === 'firm_deactivated') {
            setAssignedTaskData({ ...data });
          } else if (data?.notification_type === 'inbound_text_message' || data?.notification_type === 'text_message') {
            setTextMessageData({ ...data });
          } else if (data?.notification_type === 'outbound_status_callback') {
            setTextMessageData({ ...data });
          } else if (data?.notification_type === 'automation_error_logs') {
            setAutomationErrorLogData({ ...data });
          } else if (data && ['user_log_out', 'notification_type', 'archive_user', 'user_data_changed'].includes(data?.notification_type)) {
            setClientLogout({ ...data });
          } else if (data?.notification_type === 'ai_summary_message') {
            setAiFileSummary({ ...data });
          } else if (data?.notification_type === 'incoming_email' || data?.notification_type === 'email_is_received') {
            setCaseEmails({ ...data });
          } else if (data?.notification_type === 'ai_court_date_message') {
            setAiCourtDate({ ...data });
          } else if (data?.notification_type === 'ai_entity_message') {
            setAiEntitiesData({ ...data });
          } else if (data?.notification_type === 'ai_timeline_message') {
            setAiTimelineData({ ...data });
          } else if (data?.notification_type === 'get_folder_content_message') {
            setFolderDownloadData({ ...data });
          } else if (data?.notification_type === 'get_case_pdf_message') {
            setCaseNotePDFDownloadData({ ...data });
          }
        }
      };
      _socket.onerror = (e) => {
        setIsConnected(false);
        console.log('on connection error', e);
      };
      _socket.onclose = (e) => {
        setIsConnected(false);
        setSocket();
        _socket = null;
        let tenantId = cookie.get('tenantId') || null;
        if (!!tenantId) {
          // in case of logout the local storage is cleared and the websocket won't be reconnected
          connectToWebSocket(tenant_id, user);
        }
      };
    }
  };

  const sendMessage = async (data) => {
    try {
      return await socket.send(JSON.stringify(data), (res) => {
        console.log('websocket_reponse', res);
      });
    } catch (err) {
      console.log('websocket_error', err);
    }
  };

  const closeConnection = () => {
    try {
      if (socket) {
        socket.close();
      }
      clearInterval(interval);
      setIsConnected(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const handleOnline = () => {
      if (!isConnected) {
        setIsConnected(true);
        const tenant_id = cookie.get('tenantId');
        const user = cookie.get('user');
        const access_level = cookie.get('access_level');
        if (tenant_id && user) {
          connectToWebSocket(tenant_id, user, access_level);
        }
      }
    };

    const handleOffline = () => {
      setIsConnected(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [isConnected]);

  return (
    <WebSocketConnectionContext.Provider
      value={{
        connectToWebSocket: connectToWebSocket,
        notificationPopup: notificationPopup,
        notificationData: notificationData,
        setNotificationPopup: setNotificationPopup,
        sendMessage: sendMessage,
        closeConnection: closeConnection,
        response: response,
        setResponse: setResponse,
        setSecureMessageData: setSecureMessageData,
        secureMessageData: secureMessageData,
        secureMessageError: secureMessageError,
        setSecureMessageError: setSecureMessageError,
        setNotificationData: setNotificationData,
        assignedTask: assignedTaskData,
        setAssignedTaskData: setAssignedTaskData,
        textMessageData: textMessageData,
        setTextMessageData: setTextMessageData,
        timeEntryData: timeEntryData,
        clientLogout: clientLogout,
        automationErrorLogData: automationErrorLogData,
        setAutomationErrorLogData: setAutomationErrorLogData,
        sideBarMessages,
        setSideBarMessages,
        aiFileSummary: aiFileSummary,
        caseEmails: caseEmails,
        aiCourtDate: aiCourtDate,
        setAiCourtDate: setAiCourtDate,
        aiEntitiesData: aiEntitiesData,
        aiTimelineData: aiTimelineData,
        folderDownloadData: folderDownloadData,
        caseNotePDFDownloadData: caseNotePDFDownloadData,
        isConnected: isConnected,
      }}
    >
      {props.children}
    </WebSocketConnectionContext.Provider>
  );
};

const WebSocketConnectionConsumer = WebSocketConnectionContext.Consumer;

export { WebSocketConnectionContext, WebSocketConnectionProvider, WebSocketConnectionConsumer };
